export enum ErrorsEnum {
  InstanceExpired = 'InstanceExpired',
  InstanceNotFound = 'InstanceNotFound',
  InstanceDestroying = 'InstanceDestroying',
  UnknownError = 'UnknownError',
  FactoryNotFound = 'FactoryNotFound',
}
